/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ebeee338f718aca1fef247ba817a3ea69ab1c74a";
